module.exports = __webpack_public_path__ + "img/0Q3B8222_FoamcoreMatted.ca883934.jpg";